import Axios from "axios";
import { SECURITY_API_URL } from "../environment";
import { setRefreshToken, setToken } from "./token";

const axiosInstance = Axios.create();
axiosInstance.defaults.baseURL = SECURITY_API_URL;

export async function getAccess(authToken: string) {
  const resp = await axiosInstance?.get(`/api/authentication/token`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
  const { jwtToken, refreshTokenId } = resp.data;

  setToken(jwtToken);
  setRefreshToken(refreshTokenId);
}

export async function getAccessByCode(externalUserId: string, code: string) {
  const axiosInstance = Axios.create();
  axiosInstance.defaults.baseURL = SECURITY_API_URL;

  const resp = await axiosInstance?.post(`/api/authentication/code`, {
    externalUserId,
    code
  });
  const { jwtToken, refreshTokenId } = resp.data;

  setToken(jwtToken);
  setRefreshToken(refreshTokenId);
}

export async function requestCodeGeneration(phoneNumber: string) {
  const axiosInstance = Axios.create();
  axiosInstance.defaults.baseURL = SECURITY_API_URL;

  await axiosInstance?.post(`/api/authcode/generate`, {
    externalUserId: phoneNumber,
    sendTo: phoneNumber
  });
}